import { formatNumber } from '../floatToCurrency';
import getFormattedPrice from '../property/getFormattedPrice';

export const formatBedsValue = (value: string) => {
  return `${value} Beds`;
};

export const formatPriceValue = (suffix: string, currency: string) => (value: string) => {
  return `${getFormattedPrice(value, currency)}${suffix}`;
};

export const formatInternalArea = (value: string) => {
  const squareFeet = Math.round((parseInt(value, 10) * 10.7639) / 50) * 50;

  return `${formatNumber(squareFeet)}+ Sq ft (${formatNumber(value)}+ Sq m)`;
};

export const formatYearBuilt = (minYear?: number | null, maxYear?: number | null) => (_: string) => {
  if (minYear && maxYear) {
    return `${minYear}-${maxYear}`;
  }

  if (minYear) {
    return `Post ${minYear}`;
  }

  if (maxYear) {
    return `Pre ${maxYear}`;
  }

  return '';
};
